module.exports = __webpack_public_path__ + "static/media/logo2x.74e3b681.png";